import { render } from "./Info.vue?vue&type=template&id=c53a6e3e"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render

export default script